"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Card } from "@components/common/card";
import type { MemberDocuments } from "@lib/api/member/types";
import type { TwitterResult } from "@lib/api/wikidata/types";
import Documents from "./documents";
import TwitterFeed from "./twitter-feed";
enum Tab {
  Document = "document-tab",
  Twitter = "twitter-tab",
}
interface Props {
  memberId: string;
  initialDocuments: MemberDocuments;
  twitterFeed?: TwitterResult;
}
export default function Tabs(t0) {
  const $ = _c(19);
  const {
    memberId,
    initialDocuments,
    twitterFeed
  } = t0;
  const [activeTab, setActiveTab] = useState(Tab.Document);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function setTab(event) {
      if ("id" in event.target) {
        setActiveTab(event.target.id as Tab);
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const setTab = t1;
  const t2 = activeTab === Tab.Document;
  let t3;
  if ($[1] !== t2) {
    t3 = <button role="tab" aria-selected={t2} id={Tab.Document} onClick={setTab} className="border-teal-700 flex-1 py-4 aria-selected:border-b-2">Dokument</button>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = activeTab === Tab.Twitter;
  let t5;
  if ($[3] !== t4) {
    t5 = <button role="tab" aria-selected={t4} id={Tab.Twitter} onClick={setTab} className="border-teal-700 flex-1 py-4 aria-selected:border-b-2">Twitter-flöde</button>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3 || $[6] !== t5) {
    t6 = <div className="flex" role="tablist">{t3}{t5}</div>;
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== activeTab || $[9] !== initialDocuments || $[10] !== memberId) {
    t7 = activeTab === Tab.Document && <Documents initialDocuments={initialDocuments} memberId={memberId} />;
    $[8] = activeTab;
    $[9] = initialDocuments;
    $[10] = memberId;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== activeTab || $[13] !== twitterFeed) {
    t8 = activeTab === Tab.Twitter && <TwitterFeed twitterFeed={twitterFeed} />;
    $[12] = activeTab;
    $[13] = twitterFeed;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t7 || $[17] !== t8) {
    t9 = <Card className="overflow-visible p-0">{t6}{t7}{t8}</Card>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}